export default {
  namespaced: true,
  state: {
    notify: {},
  },
  mutations: {
    set(state, notify) {
      state.notify = { ...notify, isShow: true };
    },
    reset(state) {
      Object.assign(state, {});
    },
  },
};
